import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'healthboard/active-todo';

export const ACTIVE_TODO_TYPES = {
  SET_ACTIVE_ITEM: `${actionsScope}/set-active-item`,
};

export const activeTodoActions = {
  setActiveItem: createAction(ACTIVE_TODO_TYPES.SET_ACTIVE_ITEM),
};

const initialState = {
  activeItem: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIVE_TODO_TYPES.SET_ACTIVE_ITEM: {
      return {
        ...state,
        activeItem: payload,
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/activeTodo.js